import { saveAs } from 'file-saver';
import { parse } from 'content-disposition';
import axios from 'axios';
export const saveLinkAsFile = async (accessToken, documentLink, defaultName) => {
    var _a, _b;
    if (!documentLink) {
        return Promise.reject({
            errorCode: 'NoLink'
        });
    }
    const config = {
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        timeout: 20000,
        responseType: 'blob'
    };
    const response = await axios.get(documentLink, config);
    const contentDispositionFilename = response.headers['content-disposition']
        ? (_b = (_a = parse(response.headers['content-disposition'])) === null || _a === void 0 ? void 0 : _a.parameters) === null || _b === void 0 ? void 0 : _b.filename
        : defaultName;
    return saveAs(response.data, contentDispositionFilename);
};
export const getRedirectedUrlContent = async (url, accessToken, responseType) => {
    const config = {
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        timeout: 20000,
        responseType: responseType
    };
    let response;
    try {
        response = await axios.get(url, config);
    }
    catch (error) {
        const responeBody = error.response;
        const responseUrl = responeBody.request.responseURL;
        if (responseUrl) {
            response = await axios.get(responseUrl, { responseType: responseType });
        }
    }
    return response;
};
export const saveLinkAsFileForRedirectedUrl = async (accessToken, documentLink, defaultName) => {
    if (!documentLink) {
        return Promise.reject({
            errorCode: 'NoLink'
        });
    }
    const response = await getRedirectedUrlContent(documentLink, accessToken, 'blob');
    return saveAs(response.data, defaultName);
};
